<template>
  <div
    id="app"
    class="account-ment-page"
    :class="{ 'account-ment-page--mobile': isMobile }"
    :style="isMobile ? mobileTableStyleVars : null">
   <!-- 面包屑：名称与菜单配置同步 -->
  <AppBreadcrumb :items="[{ path: 'accountMent' }]" />

  <!-- 搜索卡片 -->
  <div class="suso">
    <el-card shadow="never" class="suso-card">
      <el-form>
        <el-form-item>
          <addre :getname="getname" @transfer="getUser" @Building="getBuilding" @unit="getUnit" @room="getRoom" @ParData="getParData" @buildingData="getbuilding" @unitData="getunit" @roomData="getroom"></addre>
        </el-form-item>
      </el-form>
    </el-card>
  </div>

  <!-- table表格卡片 -->
  <div class="tab">
    <el-card shadow="never">
      <!-- 工具栏：批量操作 -->
      <div class="table-toolbar">
        <div class="toolbar-left">
          <el-button size="small" type="primary" @click="BatchpayBtn">{{ $t('accountMent.批量缴款') }}</el-button>
          <el-button size="small" type="warning" @click="BatchrefBtn">{{ $t('accountMent.批量退款') }}</el-button>
        </div>
      </div>

      <el-table
        :data="tableData"
        size="mini"
        stripe
        highlight-current-row
        :header-cell-style="{ background: '#F4F0FF', color: '#5B3FD6', fontWeight: '500' }"
        v-loading="loading"
        @selection-change="handleSelectionChange"
        :row-class-name="rowStyle"
        :height="tableBodyHeight">
        <el-table-column type="selection" :width="isMobile ? 'auto' : 60" />
        <el-table-column v-if="!isMobile" property="pay_id" :width="isMobile ? 'auto' : 120" :label="$t('accountMent.缴费编号')" :show-overflow-tooltip="true" />
        <el-table-column property="meter_id" :label="$t('accountMent.水表编号')" :show-overflow-tooltip="true" />
        <el-table-column v-if="!isMobile || !mobileHideUsername" property="username" :label="$t('accountMent.用户姓名')" :show-overflow-tooltip="true" />
        <el-table-column v-if="!isMobile" property="phone" :label="$t('accountMent.联系方式')" />
        <el-table-column v-if="!isMobile" property="address" :label="$t('accountMent.地址')" />
        <el-table-column property="balance" :label="$t('accountMent.余额')" :width="isMobile ? 'auto' : 120" :show-overflow-tooltip="true" />
        <el-table-column property="valve" :label="$t('accountMent.操作')" :width="isMobile ? 'auto' : 200" :fixed="isMobile ? 'right' : false">
          <template slot-scope="scope">
            <template v-if="isMobile">
              <el-dropdown
                trigger="click"
                :disabled="!scope.row.meter_id"
                @command="(cmd) => handleMobileOp(cmd, scope.row)">
                <el-button class="mobile-op-btn" size="mini" type="primary" :disabled="!scope.row.meter_id">
                  {{ $t('accountMent.操作') }}<i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="pay">{{ $t('accountMent.缴款') }}</el-dropdown-item>
                  <el-dropdown-item command="refund">{{ $t('accountMent.退款') }}</el-dropdown-item>
                  <el-dropdown-item command="detail">详情</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
            <template v-else>
              <el-button type="text" size="mini" @click="ficsati(scope.row)" v-show="scope.row.meter_id">{{ $t('accountMent.缴款') }}</el-button>
              <el-button type="text" size="mini" disabled v-show="!scope.row.meter_id">{{ $t('accountMent.缴款') }}</el-button>
              <el-button type="text" size="mini" class="btn-refund" @click="opens(scope.row)" v-show="scope.row.meter_id">{{ $t('accountMent.退款') }}</el-button>
              <el-button type="text" size="mini" disabled v-show="!scope.row.meter_id">{{ $t('accountMent.退款') }}</el-button>
            </template>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        class="acc-pagination"
        :small="isMobile"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="famlis.pagenum"
        :page-sizes="[20, 40, 60, 80, 100]"
        :page-size="famlis.pagesize"
        :layout="paginationLayout"
        :pager-count="isMobile ? 5 : 7"
        :total="total">
      </el-pagination>
    </el-card>
  </div>

  <!-- 批量缴费弹框 -->
  <div class="locationOpenvalve">
    <el-dialog
      :title="$t('accountMent.水费交款')"
      :visible.sync="Batchvais">
      <div class="Periodic">
        <span>{{ $t('accountMent.当前勾选') }}: {{lengthid}} {{ $t('accountMent.台设备') }}</span>
        <el-checkbox v-model="batchRtss.regional_issued">{{ $t('accountMent.选择当前区域所有设备') }}({{total}}){{ $t('accountMent.条') }}</el-checkbox>
      </div>
      <div class="Batchinput">
        <span>{{ $t('accountMent.交款') }}: </span>
        <el-input v-model.trim="batchRtss.money" :placeholder="$t('accountMent.请输入金额')"></el-input>
      </div>
      <div class="xuanxiang">
        <div v-for="(list,index) in payconfigEntities" :key="index" v-bind:class="{colorChange:index==dynamic}" direction="column" @click="getMoney(index)">
          <el-button>{{ $t('accountMent.' + getPaymentTypeKey(list.effect)) }}</el-button>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="batchBhci">{{ $t('accountMent.确定') }}</el-button>
      </span>
    </el-dialog>
  </div>

  <!-- 缴费弹框 -->
  <div class="locationOpenvalve">
    <el-dialog
      :title="$t('accountMent.水费交款')"
      :visible.sync="diaes">
      <div class="diaonum">
        <div class="diaonsums">
          <span>{{ $t('accountMent.水表编号') }}: </span>
          <span>{{ficsData.meter_id}}</span>
        </div>
        <div class="diaonsums">
          <span>{{ $t('accountMent.用户姓名') }}: </span>
          <span>{{ficsData.username}}</span>
        </div>
        <div class="diaonsums">
          <span>{{ $t('accountMent.余额') }}: </span>
          <span>{{ficsData.balance}}</span>
        </div>
      </div>
      <div class="diaoninput">
        <span :style="{ width: isMobile ? '43px' : '100px' }">{{ $t('accountMent.备注') }}: </span>
        <el-input type="text" v-model="ficsData.note" size='small '/>
      </div>
      <div class="diaoinput">
        <span>{{ $t('accountMent.交款') }}: </span>
        <el-input v-model.trim="accounRtss.money" :placeholder="$t('accountMent.请输入金额')"></el-input>
      </div>
      <div class="xuanxiang">
        <div v-for="(list,index) in payconfigEntities" :key="index" v-bind:class="{colorChange:index==dynamic}" direction="column" @click="getMoney(index)">
          <el-button>{{ $t('accountMent.' + getPaymentTypeKey(list.effect)) }}</el-button>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="ficsBhci">{{ $t('accountMent.确定') }}</el-button>
      </span>
    </el-dialog>
  </div>

  <!-- 批量退款弹框 -->
  <div class="locationOpenvalve">
    <el-dialog
      :title="$t('accountMent.水费退款')"
      :visible.sync="Batchredvais">
      <div class="Periodic">
        <span>{{ $t('accountMent.当前勾选') }}: {{lengthid}} {{ $t('accountMent.台设备') }}</span>
        <el-checkbox v-model="batchRefund.regional_issued">{{ $t('accountMent.选择当前区域所有设备') }}({{total}}){{ $t('accountMent.条') }}</el-checkbox>
      </div>
      <div class="Batchinput">
        <span>{{ $t('accountMent.退款') }}: </span>
        <el-input v-model.trim="batchRefund.money" :placeholder="$t('accountMent.请输入金额')"></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="BatchRefund">{{ $t('accountMent.确定') }}</el-button>
      </span>
    </el-dialog>
  </div>

  <!-- 退费弹框 -->
  <div class="locationOpenvalve">
    <el-dialog
      :title="$t('accountMent.水费退款')"
      :visible.sync="diatui">
      <div class="diaonum">
        <div class="diaonsums">
          <span>{{ $t('accountMent.水表编号') }}: </span>
          <span>{{ficsnData.meter_id}}</span>
        </div>
        <div class="diaonsums">
          <span>{{ $t('accountMent.用户姓名') }}: </span>
          <span>{{ficsnData.username}}</span>
        </div>
        <div class="diaonsums">
          <span>{{ $t('accountMent.余额') }}: </span>
          <span>{{ficsnData.balance}}</span>
        </div>
        <div class="diaonsums">
          <span>{{ $t('accountMent.可退款金额') }}: </span>
          <span>{{return_money_balance}}</span>
        </div>
      </div>
      <div class="diaoninput">
        <span :style="{ width: isMobile ? '43px' : '100px' }">{{ $t('accountMent.备注') }}: </span>
        <el-input type="text" v-model="ficsnData.note" size='small '/>
      </div>
      <div class="diaoinput">
        <span>{{ $t('accountMent.退款') }}: </span>
        <el-input v-model.trim="accounRefss.money" :placeholder="$t('accountMent.请输入金额')"></el-input>
      </div>
      <div class="sssccc">{{ $t('accountMent.注：退费金额=余额-其它收费金额') }}</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="diuayt">{{ $t('accountMent.确定') }}</el-button>
      </span>
    </el-dialog>
  </div>

  <!-- 打印凭据 -->
  <div class="locationOpenvalve">
    <el-dialog
      :title="$t('accountMent.充值凭证')"
      :visible.sync="dayinpingz">
      <div id="printMe">
        <div class="pingzs">{{ $t('accountMent.充值凭证') }}</div>
        <div class="dayinum">
          <div>{{ $t('accountMent.订单编号') }}:{{dayin.id}}</div>
          <div>{{ $t('accountMent.收款日期') }}:{{dayin.create_time}}</div>
        </div>
        <div class="dayininput">
          <div class="inputs">
            <span>{{ $t('accountMent.缴费编号') }}:{{dayin.pay_id}}</span>
            <span>{{ $t('accountMent.水表编号') }}:{{dayin.meter_id}}</span>
          </div>
          <div class="inputs">
            <span>{{ $t('accountMent.用户姓名') }}:{{dayin.username}}</span>
            <span>{{ $t('accountMent.当前表码') }}:{{dayin.current_sum_flow}}</span>
          </div>
          <div class="inputs">
            <span style="width: 100%">{{ $t('accountMent.地址信息') }}:{{dayin.address}}</span>
          </div>
          <div class="inputs">
            <span>{{ $t('accountMent.充值金额') }}:{{dayin.amount}}</span>
            <span>{{ $t('accountMent.账户余额') }}:{{dayin.aft_money}}</span>
          </div>
        </div>
        <div class="dayincao">{{ $t('accountMent.操作人员') }}:{{dayin.operate_user}}</div>
      </div>
      <span slot="footer" class="dayinbtn">
        <span class="spaois">{{ $t('accountMent.手机可以截个图作为凭证') }}</span>
        <el-button class="spanbtn" type="info" size="mini" v-print="printObj">{{ $t('accountMent.打印') }}</el-button>
        <el-button type="info" size="mini" @click="prinqxio">{{ $t('accountMent.取消') }}</el-button>
      </span>
    </el-dialog>
  </div>

  <!-- 手机端：行详情 -->
  <div class="locationOpenvalve" v-if="isMobile">
    <el-dialog title="详情" :visible.sync="mobileDetailVisible">
      <div class="mobile-detail-body">
        <div class="mobile-detail-item" v-for="(item, idx) in mobileDetailFields" :key="idx">
          <span class="k">{{ item.label }}：</span>
          <span class="v">{{ item.value }}</span>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="mobileDetailVisible = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
  </div>
</template>
<script>
import addre from '../../../components/address'
export default {
components: { addre },
inject: ['reload'],
data () {
  return {
    payconfigEntities: [
      { effect: '业务售水' },
      { effect: '优惠售水' },
      { effect: '系统结转' }
    ],
    dynamic: -1,
    printObj: {
      id: 'printMe',
      popTitle: '',
      extraCss: 'https://www.google.com,https://www.google.com',
      extraHead: '<meta http-equiv="Content-Language"content="zh-cn"/>,<style> #printMe { height: auto !important; } <style>'
    },
    ficsData: {},
    Batchredvais: false,
    Batchvais: false,
    diatui: false,
    diaes: false,
    dayinpingz: false,
    formLabelWidth: '100px',
    seldata: [],
    options: [
      {
        name: '金湖'
      }
    ],
    tableData: [
      {
        project_name: null,
        name: null,
        project_address: null,
        username: null,
        valve: null
      }
    ],
    total: 0,
    loading: true,
    famlis: {
      project_id: null,
      token: null,
      pagenum: 1,
      pagesize: 20
    },
    tableSize: null,
    batchRtss: {
      token: null,
      pay_id_list: null,
      regional_issued: null,
      money: null,
      charge_type: null
    },
    accounRtss: {
      token: null,
      pay_id: null,
      money: null,
      charge_type: null
    },
    dayin: {},
    batchRefund: {
      token: null,
      pay_id_list: null,
      money: null,
      regional_issued: null
    },
    ficsnData: {},
    accounRefss: {
      project_id: null,
      token: null,
      pay_id: null,
      return_money_balance: 1,
      operate_user_id: null,
      money: null
    },
    refund: {
      token: null,
      pay_id: null,
      return_money_balance: 1
    },
    zaisns: [{
      id: 1,
      name: null
    }],
    cxyts: {
      project_id: null,
      token: null,
      pay_id: null,
      search_content: null,
      location_id: null
    },
    lengthid: null,
    emptyFlag: 0,
    return_money_balance: null,
    ids: [],
    isMobile: false,
    mobileTableScale: 1,
    mobileTableFont: 11,
    mobileCellPadX: 2,
    mobileCellPadY: 4,
    mobileBtnFont: 11,
    mobileBtnPadX: 6,
    mobileBtnPadY: 4,
    mobileSelWidth: 44,
    mobileOpColWidth: 92,
    mobileHideUsername: false,
    mobileDetailVisible: false,
    mobileDetailRow: {},
    _tabResizeObserver: null
  }
},
computed: {
  paginationLayout () {
    return this.isMobile ? 'prev, pager, next' : 'total, sizes, prev, pager, next, jumper'
  },
  tableBodyHeight () {
    return this.isMobile ? 360 : 500
  },
  mobileTableStyleVars () {
    return {
      '--m-table-font': this.mobileTableFont + 'px',
      '--m-cell-pad-x': this.mobileCellPadX + 'px',
      '--m-cell-pad-y': this.mobileCellPadY + 'px',
      '--m-btn-font': this.mobileBtnFont + 'px',
      '--m-btn-pad-x': this.mobileBtnPadX + 'px',
      '--m-btn-pad-y': this.mobileBtnPadY + 'px'
    }
  },
  mobileDetailFields () {
    const row = this.mobileDetailRow || {}
    const safe = (v) => (v === null || v === undefined || v === '' ? '-' : String(v))
    return [
      { label: this.$t('accountMent.缴费编号'), value: safe(row.pay_id) },
      { label: this.$t('accountMent.水表编号'), value: safe(row.meter_id) },
      { label: this.$t('accountMent.用户姓名'), value: safe(row.username) },
      { label: this.$t('accountMent.联系方式'), value: safe(row.phone) },
      { label: this.$t('accountMent.地址'), value: safe(row.address) },
      { label: this.$t('accountMent.余额'), value: safe(row.balance) }
    ]
  }
},
created () {
  this.famlis.token = this.$store.state.print.goodsForeNo.token
  this.tabData()
  this.refund.token = this.$store.state.print.goodsForeNo.token
  if (typeof window !== 'undefined') {
    this.isMobile = window.innerWidth <= 768
  }
},
mounted () {
  this.checkMobile()
  window.addEventListener('resize', this.checkMobile, { passive: true })
  this.$nextTick(() => {
    this.updateMobileTableLayout()
    if (typeof ResizeObserver !== 'undefined') {
      const el = this.$el && this.$el.querySelector && this.$el.querySelector('.tab')
      if (el) {
        this._tabResizeObserver = new ResizeObserver(() => this.updateMobileTableLayout())
        this._tabResizeObserver.observe(el)
      }
    }
  })
},
beforeDestroy () {
  window.removeEventListener('resize', this.checkMobile)
  if (this._tabResizeObserver) {
    try { this._tabResizeObserver.disconnect() } catch (e) {}
    this._tabResizeObserver = null
  }
},
methods: {
  checkMobile () {
    this.isMobile = typeof window !== 'undefined' && window.innerWidth <= 768
    this.$nextTick(() => this.updateMobileTableLayout())
  },
  updateMobileTableLayout () {
    if (!this.isMobile) return
    const tabEl = this.$el && this.$el.querySelector && this.$el.querySelector('.tab')
    const w = tabEl ? tabEl.clientWidth : 0
    if (!w) return
    this.mobileHideUsername = w < 340

    const target = this.mobileHideUsername ? 300 : 360
    const scale = Math.min(1, Math.max(0.72, w / target))
    this.mobileTableScale = scale

    const clamp = (n, min, max) => Math.max(min, Math.min(max, n))
    this.mobileTableFont = clamp(Math.round(11 * scale), 2, 11)
    this.mobileCellPadX = clamp(Math.round(2 * scale), 1, 2)
    this.mobileCellPadY = clamp(Math.round(4 * scale), 2, 4)
    this.mobileBtnFont = clamp(Math.round(11 * scale), 9, 11)
    this.mobileBtnPadX = clamp(Math.round(6 * scale), 4, 6)
    this.mobileBtnPadY = clamp(Math.round(4 * scale), 2, 4)
    this.mobileSelWidth = clamp(Math.round(44 * scale), 34, 44)
    this.mobileOpColWidth = clamp(Math.round(92 * scale), 72, 92)
  },
  handleMobileOp (cmd, row) {
    if (cmd === 'detail') {
      if (!row) return
      this.mobileDetailRow = { ...row }
      this.mobileDetailVisible = true
      return
    }
    if (!row || !row.meter_id) return
    if (cmd === 'pay') this.ficsati(row)
    if (cmd === 'refund') this.opens(row)
  },
  getMoney: function (index) {
    this.dynamic = index
    console.log(this.dynamic, 'console.log(dynamic)')
    this.accounRtss.charge_type = this.dynamic
    this.batchRtss.charge_type = this.dynamic
  },
  getname (name) {
    console.log('App收到了子组件传过来的数据', name)
    this.tableData = name.data
    this.total = name.total
  },
  getUser (data) {
    console.log('小区id：', data)
    this.batchRtss.community_id = data
    this.batchRefund.community_id = data
    this.community_id = data
  },
  getBuilding (data) {
    console.log('楼栋id：', data)
    this.batchRtss.building_id = data
    this.batchRefund.building_id = data
    this.building_id = data
  },
  getUnit (data) {
    console.log('单元子id：', data)
    this.batchRtss.unit_id = data
    this.batchRefund.unit_id = data
    this.unit_id = data
  },
  getRoom (data) {
    console.log('房间id：', data)
    this.batchRtss.room_id = data
    this.batchRefund.room_id = data
    this.room_id = data
  },
  getParData (data) {
    console.log(data, '选中单元刷新数据')
    this.tableData = data.data.data
    this.total = data.data.total
  },
  getbuilding (data) {
    console.log(data, '选中楼栋刷新数据')
    this.tableData = data.data.data
    this.total = data.data.total
  },
  getunit (data) {
    console.log(data, '选中单元刷新数据')
    this.tableData = data.data.data
    this.total = data.data.total
  },
  getroom (data) {
    console.log(data, '选中单元刷新数据')
    this.tableData = data.data.data
    this.total = data.data.total
  },
  handleSelectionChange (val) {
    this.ids = val.map(item => item.pay_id)
    console.log(this.ids, 'this.ids')
    this.lengthid = val.length
    const arr = []
    val.forEach(function (value) {
      arr.push(value.pay_id)
    })
    this.batchRtss.pay_id_list = arr
    this.batchRefund.pay_id_list = arr
  },
  rowStyle ({ row, rowIndex }) {
    var arrs = this.ids
    for (let i = 0; i < arrs.length; i++) {
      console.log(row.pay_id, arrs[i], 'row.pay_id,arrs')
      if (row.pay_id === arrs[i]) {
        return 'rowStyle'
      }
    }
  },
  prinqxio () {
    this.dayinpingz = false
  },
  pay_search () {
    this.cxyts.project_id = this.$store.state.print.goodsForeNo.project_id
    this.cxyts.token = this.$store.state.print.goodsForeNo.token
    this.$api.userProfile.Czhixios(this.cxyts).then((res) => {
      console.log(res, '查询')
      this.tableData = res.data.data
      this.total = res.data.total
    })
  },
  shuaxin () {
    this.reload()
  },
  BatchrefBtn () {
    this.Batchredvais = true
  },
  BatchRefund () {
    this.batchRefund.token = this.$store.state.print.goodsForeNo.token
    this.$api.accountMent.accounRefunds(this.batchRefund).then((res) => {
      console.log(res, '批量缴费')
      if (res.data.status === 'success') {
        this.tabData()
        this.$message({
          type: 'success',
          message: res.data.message
        })
        this.$notify({
          title: res.data.message,
          message: res.data.error_list,
          duration: 0
        })
        this.tabData()
      } else if (res.data.status === 'error') {
        this.$message.error(res.data.message)
      }
      if (res.data.message === '用户在别处登录') {
        this.$router.push('/', this.fasinull)
      }
    })
    this.Batchredvais = false
  },
  BatchpayBtn () {
    this.Batchvais = true
  },
  batchBhci () {
    this.batchRtss.token = this.$store.state.print.goodsForeNo.token
    this.emptyFlag = 0
    this.$api.accountMent.accounBzhits(this.batchRtss).then((res) => {
      console.log(res, '批量缴费')
      if (res.data.status === 'success') {
        this.emptyFlag = 1
        this.tabData()
        this.$message({
          type: 'success',
          message: '缴费成功!'
        })
        this.tabData()
      } else if (res.data.status === 'error') {
        this.$message.error(res.data.message)
      }
      if (res.data.message === '用户在别处登录') {
        this.$router.push('/', this.fasinull)
      }
    })
    this.Batchvais = false
  },
  ficsBhci () {
    this.$confirm('是否要对' + this.ficsData.meter_id + '表进行缴费', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      this.accounRtss.token = this.$store.state.print.goodsForeNo.token
      this.$api.accountMent.accounBzhits(this.accounRtss).then((res) => {
        if (res.data.status === 'success') {
          console.log(res, '缴费')
          this.dayin = res.data.data
          this.tabData()
          this.$message({
            type: 'success',
            message: '缴费成功!'
          })
          this.dayinpingz = true
        } else if (res.data.status === 'error') {
          this.$message.error(res.data.message)
        }
        if (res.data.message === '用户在别处登录') {
          this.$router.push('/', this.fasinull)
        }
      })
      this.diaes = false
    }).catch(() => {
      this.$message({
        type: 'info',
        message: '已取消缴费'
      })
    })
  },
  ficsati (row) {
    console.log(row)
    this.ficsData = row
    this.accounRtss.pay_id = row.pay_id
    this.diaes = true
  },
  diuayt () {
    this.accounRefss.token = this.$store.state.print.goodsForeNo.token
    this.accounRefss.operate_user_id = this.$store.state.print.goodsForeNo.id
    this.$api.accountMent.accounRefunds(this.accounRefss).then((res) => {
      if (res.data.status === 'success') {
        console.log(res, '退费')
        this.tabData()
        this.reload()
        this.$message({
          type: 'success',
          message: '退费成功!'
        })
      } else if (res.data.status === 'error') {
        this.$message.error(res.data.message)
      }
      if (res.data.message === '用户在别处登录') {
        this.$router.push('/', this.fasinull)
      }
    })
    this.diatui = false
    this.ficsnData.note = null
    this.accounRefss.money = null
  },
  opens (row) {
    console.log(row)
    this.ficsnData = row
    this.accounRefss.pay_id = row.pay_id
    this.refund.pay_id = row.pay_id
    this.diatui = true
    this.$api.accountMent.getuserRefund(this.refund).then((res) => {
      console.log(res.data.data.return_money_balance, '获取可退款金额')
      this.return_money_balance = res.data.data.return_money_balance
    })
  },
  tabData () {
    this.$api.accountMent.accounDatas(this.famlis).then((res) => {
      if (res.data.status === 'success') {
        console.log(res, 'res')
        this.tableData = res.data.data
        this.loading = false
        this.total = res.data.total
      } else if (res.data.status === 'error') {
        this.$message.error(res.data.message)
      }
      if (res.data.message === '用户在别处登录') {
        this.$router.push('/', this.fasinull)
      }
    })
  },
  handleSizeChange (newSize) {
    console.log(newSize, 'q')
    this.famlis.pagesize = newSize
    this.tabData()
  },
  handleCurrentChange (newPage) {
    console.log(newPage, '123')
    this.famlis.pagenum = newPage
    this.famlis.search_content = this.cxyts.search_content
    this.famlis.location_id = this.cxyts.location_id
    this.famlis.community_id = this.community_id
    this.famlis.building_id = this.building_id
    this.famlis.unit_id = this.unit_id
    this.famlis.room_id = this.room_id
    this.tabData()
  },
  getPaymentTypeKey (effect) {
    switch (effect) {
      case '业务售水':
        return 'businessWaterSales'
      case '优惠售水':
        return 'discountWaterSales'
      case '系统结转':
        return 'systemTransfer'
      default:
        return effect
    }
  }
}
}
</script>

<style lang="less" scoped>
.colorChange {
.el-button {
  background-color: #987AFF;
  color: #fff;
}
}

/* 面包屑 */
.Gnv {
width: 100%;
height: 32px;
display: flex;
align-items: center;
background-color: #ecf0f1;
font-size: 19px;
letter-spacing: 1px;

.el-breadcrumb {
  display: flex;
  align-items: center;
  margin-left: 20px;

  .yai {
    width: 5px;
    height: 17px;
    background-color: #987AFF;
    margin-right: 18px;
  }

  ::v-deep .el-breadcrumb__item {
    margin-left: 0px;
    .el-breadcrumb__inner.is-link {
      font-weight: 100;
      color: #656d92;
    }
  }
}
}

/* 搜索卡片 */
.suso {
padding: 16px 20px 0;

.suso-card {
  border-radius: 10px;
  border: 1px solid #F0F0F5;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.03);

  ::v-deep .el-card__body {
    padding: 18px 20px 6px;
  }
}

.el-form {
  display: flex;

  .el-input {
    border-radius: 6px;
    width: 200px;
  }

  .el-button {
    margin-left: 10px;
    background-color: #744dfe;
    border: 0px;
  }

  .sele {
    width: 100px;
    margin-left: 50px;
  }
}
}

/* table表格卡片 */
.tab {
padding: 16px 20px 20px;

.el-card {
  border-radius: 10px;
  border: 1px solid #F0F0F5;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.03);

  ::v-deep .el-card__body {
    padding: 16px 16px 12px;
  }
}

/* 顶部工具栏 */
.table-toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;

  .toolbar-left {
    display: flex;
    gap: 8px;
  }
}

/* 表头轻量化（配合 :header-cell-style 使用，双保险） */
::v-deep .el-table th {
  background-color: #F4F0FF !important;
  color: #5B3FD6 !important;
  font-weight: 500 !important;
  border-bottom: 1px solid #E9E3FF !important;
}

::v-deep .el-table tr {
  background-color: #fff;
}

::v-deep .el-table--striped .el-table__body tr.el-table__row--striped td {
  background: #FAF9FF;
}

::v-deep .el-table__header-wrapper {
  width: 100%;
}

::v-deep .el-table__header {
  width: 0;
  width: 100%;
}

::v-deep .cell {
  font-family: myFont;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
  text-align: center;
}

/* 操作列文字按钮（桌面端） */
::v-deep .el-table .el-button--text {
  padding: 4px 6px;
  color: #744dfe;
  background: transparent;
  border: none;

  &:hover {
    background: #F2EDFF;
    border-radius: 4px;
  }

  &.is-disabled {
    color: #c0c4cc !important;
    background: transparent;
  }
}

/* 退款按钮走暖色，跟缴款区分 */
::v-deep .el-table .btn-refund {
  color: #F56C6C;

  &:hover {
    background: #FFF1F0;
    color: #F56C6C;
  }
}

/* 分页居右 */
.acc-pagination {
  margin-top: 16px;
  display: flex;
  justify-content: flex-end;
}
}

/* 仅手机端 */
.account-ment-page--mobile {
font-size: 12px;
line-height: 1.35;

.Gnv {
  display: none;
}

.suso {
  padding: 8px 10px 0 !important;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 8px;

  .suso-card {
    ::v-deep .el-card__body {
      padding: 10px;
    }
  }

  > .el-form {
    display: flex;
    flex-direction: column;
    width: 100%;
    order: 0;
  }

  > .el-form .el-form-item {
    margin-bottom: 6px !important;
    margin-top: 0 !important;
    margin-right: 0 !important;
  }
}

.tab {
  padding: 8px 10px 10px !important;
  min-width: 0;
  overflow-x: hidden;

  .el-card {
    ::v-deep .el-card__body {
      padding: 10px;
    }
  }

  /* 移动端工具栏 */
  .table-toolbar {
    display: flex;
    gap: 6px;
    margin-bottom: 8px;

    .toolbar-left {
      display: flex;
      flex: 1;
      gap: 6px;

      .el-button {
        flex: 1 1 0;
        min-width: 0;
        padding: 10px 6px;
        font-size: 14px;
        height: auto;
        line-height: 1.4;
        white-space: nowrap;
      }
    }
  }

  ::v-deep .el-table {
    font-size: 16px;
    font-size: var(--m-table-font, 16px);
  }

  ::v-deep .el-table th .cell {
    font-size: var(--m-table-font, 14px);
    padding: var(--m-cell-pad-y, 14px) var(--m-cell-pad-x, 14px);
  }

  ::v-deep .el-table td .cell {
    padding: var(--m-cell-pad-y, 14px) var(--m-cell-pad-x, 14px);
    font-size: var(--m-table-font, 14px);
  }

  ::v-deep .el-table .el-button--mini {
    padding: var(--m-btn-pad-y, 4px) var(--m-btn-pad-x, 9px);
    font-size: var(--m-btn-font, 14px);
    margin: 2px;
  }

  ::v-deep .mobile-op-btn {
    width: 100%;
    padding: var(--m-btn-pad-y, 14px) var(--m-btn-pad-x, 14px) !important;
    font-size: var(--m-btn-font, 14px) !important;
    line-height: 1.1;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    white-space: nowrap;
    min-width: 0;
  }

  ::v-deep .el-table__body-wrapper {
    overflow-x: hidden !important;
  }

  ::v-deep .el-table__header-wrapper {
    overflow-x: hidden !important;
  }

  ::v-deep .el-table .cell {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

.acc-pagination {
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  padding: 6px 4px 10px;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  row-gap: 4px;

  ::v-deep .el-pagination__total,
  ::v-deep .el-pagination__sizes,
  ::v-deep .el-pagination__jump {
    display: none;
  }

  ::v-deep .btn-prev,
  ::v-deep .btn-next,
  ::v-deep .el-pager li {
    min-width: 26px;
    font-size: 12px;
  }
}

/* 手机端：弹框自适应 */
::v-deep .locationOpenvalve .el-dialog {
  max-width: 92vw;
}

::v-deep .locationOpenvalve .el-dialog__body {
  overflow-x: hidden;
}

::v-deep .locationOpenvalve .Periodic {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  font-size: 12px;
  line-height: 1.2;
}

::v-deep .locationOpenvalve .Periodic > span {
  flex: 0 1 auto;
  width: auto;
  white-space: nowrap;
  overflow: visible;
  text-overflow: clip;
}

::v-deep .locationOpenvalve .Periodic .el-checkbox {
  flex: 0 1 auto;
  width: auto;
  white-space: nowrap;
}

::v-deep .locationOpenvalve .Periodic .el-checkbox__label {
  white-space: nowrap;
  max-width: 100%;
  overflow: visible;
  text-overflow: clip;
  display: inline;
}

::v-deep .locationOpenvalve .Batchinput,
::v-deep .locationOpenvalve .diaoinput,
::v-deep .locationOpenvalve .diaoninput {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  gap: 8px;
  white-space: nowrap;
  font-size: 12px;
}

::v-deep .locationOpenvalve .Batchinput > span,
::v-deep .locationOpenvalve .diaoinput > span {
  flex: 0 0 auto;
  white-space: nowrap;
  font-size: 14px;
  color: #744dfe;
  letter-spacing: 0 !important;
}

::v-deep .locationOpenvalve .diaoninput > span {
  flex: 0 0 auto;
  white-space: nowrap;
  font-size: 12px;
  letter-spacing: 0 !important;
}

::v-deep .locationOpenvalve .Batchinput .el-input,
::v-deep .locationOpenvalve .diaoinput .el-input,
::v-deep .locationOpenvalve .diaoninput .el-input {
  flex: 1 1 0;
  min-width: 0;
  max-width: 100%;
}

::v-deep .locationOpenvalve .Batchinput .el-input__inner,
::v-deep .locationOpenvalve .diaoinput .el-input__inner,
::v-deep .locationOpenvalve .diaoninput .el-input__inner {
  height: 32px;
  width: 160px;
  line-height: 32px;
  font-size: 16px;
  padding: 0 8px;
}

::v-deep .locationOpenvalve .xuanxiang {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 6px;
  margin-top: 10px;
}

::v-deep .locationOpenvalve .xuanxiang > div {
  min-width: 0;
}

::v-deep .locationOpenvalve .xuanxiang .el-button {
  width: 100%;
  padding: 10px 6px;
  font-size: 12px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

::v-deep .locationOpenvalve .dialog-footer {
  display: flex;
  justify-content: flex-end;
  flex-wrap: nowrap;
  white-space: nowrap;
  gap: 8px;
}

::v-deep .locationOpenvalve .dialog-footer .el-button {
  white-space: nowrap;
  padding: 10px 12px;
  font-size: 14px;
  background-color: #744dfe;
  color: #fff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  line-height: 1;
}

/* 手机端：缴费/退费详情弹框信息区字号 14px */
::v-deep .el-dialog .diaonum,
::v-deep .el-dialog .diaonum .diaonsums,
::v-deep .el-dialog .diaonum .diaonsums span {
  font-size: 14px !important;
  letter-spacing: 0 !important;
  line-height: 1.6 !important;
}

::v-deep .mobile-detail-body {
  max-height: 50vh;
  overflow-y: auto;
}

::v-deep .mobile-detail-item {
  display: flex;
  align-items: flex-start;
  gap: 6px;
  padding: 4px 0;
  font-size: 12px;
  line-height: 1.4;
  border-bottom: 1px dashed #eee;
}

::v-deep .mobile-detail-item .k {
  flex: 0 0 auto;
  color: #606266;
  white-space: nowrap;
}

::v-deep .mobile-detail-item .v {
  flex: 1 1 auto;
  min-width: 0;
  color: #303133;
  word-break: break-all;
}
}

/* 缴费提示弹框 */
.el-dialog {
width: 30%;

.el-dialog__header {
  span.dialog__title {
    font-family: SimHei;
    font-size: 25px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 9px;
    letter-spacing: 5px;
    color: #030000;
  }
}

.diaonum {
  margin-left: 20px;
  font-family: XinPingHeiTC-W2;
  font-size: 19px;
  font-stretch: normal;
  line-height: 45px;
  letter-spacing: 4px;
  color: #484848;

  .diaonsums {
    font-family: XinPingHeiTC-W2;
    font-size: 19px;
    letter-spacing: 10px;
    color: #484848;

    span {
      font-family: XinPingHeiTC-W2;
      font-size: 19px;
      letter-spacing: 4px;
      color: #484848;
    }
  }
}

.diaoninput {
  margin-left: 20px;
  display: flex;
  align-items: center;

  span {
    font-family: XinPingHeiTC-W2;
    font-size: 19px;
    letter-spacing: 4px;
    color: #484848;
  }
}

.diaoinput {
  margin: 20px 0px 0px 20px;
  display: flex;
  align-items: center;

  span {
    font-family: BENMOJingyuan;
    font-size: 30px;
    font-weight: normal;
    letter-spacing: 1px;
    color: #744dfe;
  }

  .el-input {
    width: 120px;
    margin-left: 10px;
    margin-top: 5px;
  }
}

.sssccc {
  margin: 20px 0px 0px 100px;
  display: flex;
  align-items: center;
  color: brown;
}

.dialog-footer {
  .el-button {
    font-size: 20px;

    i {
      margin-right: 10px;
      font-size: 24px;
    }
  }
}
}

.xuanxiang {
margin-top: 20px;
display: flex;
}

/* 充值打印 */
#printMe {
border: 1px solid;
padding: 10px 0px;

.pingzs {
  width: 90%;
  height: 20px;
  font-size: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.dayinum {
  padding: 0px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.dayininput {
  width: 96%;
  height: 130px;
  border: 1px solid;
  line-height: 32px;
  margin: 10px auto;
}

.inputs {
  padding: 0px 20px 0px 20px;
  display: flex;
  justify-content: space-between;

  span {
    width: 50%;
  }
}

.dayincao {
  margin-left: 400px;
  width: 200px;
}

.dayinbtn {
  button {
    font-size: 14px;
  }
}
}

.locationOpenvalve {
.el-dialog__wrapper {
  ::v-deep .el-dialog {
    width: 30%;
  }
}

.Periodic {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.Batchinput {
  margin-top: 20px;
  display: flex;
  align-items: center;

  span {
    font-family: BENMOJingyuan;
    font-size: 30px;
    font-weight: normal;
    letter-spacing: 1px;
    color: #744dfe;
  }

  .el-input {
    width: 100px;
    margin-left: 10px;
    margin-top: 5px;
  }
}
}

/deep/ .rowStyle {
background-color: oldlace !important;
}

/* 移动端 */
@media (min-width: 768px) {
.spaois {
  display: none;
}
}

@media (max-width: 768px) {
.spaois {
  font-size: 12px;
  color: brown;
}

.spanbtn {
  display: none;
}

.Gnv {
  display: none;
}

.el-dialog {
  width: 92%;
}

.locationOpenvalve {
  .el-dialog__wrapper {
    ::v-deep .el-dialog {
      width: 92%;
    }
  }
}

::v-deep .el-dialog__body {
  padding: 10px 10px;
}

.el-dialog .diaonum {
  margin-left: 6px;
}

.el-dialog .diaoninput {
  margin-left: 6px;
}

.el-dialog .diaoinput {
  margin-left: 6px;
}

.el-dialog .sssccc {
  margin: 20px 0px;
}
}
</style>